import { useQuery } from 'react-query';
import { ShareRow, stableDocsService } from '../services/stabledocsService';

export const stableDocsSharesKey = (horseId: string | undefined) => ['stabledocs', 'shares', horseId];

/** What has been sent from this chart; the timeline shows each one as a "StableDocs sent" entry. */
export function useStableDocsShares(horseId: string | undefined, enabled: boolean) {
  return useQuery<ShareRow[]>(stableDocsSharesKey(horseId), () => stableDocsService.listShares(horseId!), {
    enabled: !!horseId && enabled,
    staleTime: 60_000,
    retry: false,
  });
}
